__turbopack_context__.v({
  "container": "container-module-scss-module__8iptMG__container",
  "containerFluid": "container-module-scss-module__8iptMG__containerFluid",
  "containerMiddle": "container-module-scss-module__8iptMG__containerMiddle",
  "containerNarrow": "container-module-scss-module__8iptMG__containerNarrow",
  "containerWide": "container-module-scss-module__8iptMG__containerWide",
});
